<template>
  <button
    class="close-button"
    @click="handleClick"
    aria-label="Close"
  >
    <i class="close-button-icon"></i>
  </button>
</template>

<script>
export default {
  name: 'CloseButton',
  props: ['handleClick'],
}
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/color-theme';

  .close-button {
    width: 2rem;
    height: 2rem;
    margin: {
      top: 1rem;
      right: 1rem;
      bottom: 1rem;
      left: auto;
    };
    padding: 0;
    background: none;
    border: 0;

    &-icon {
      position: relative;
      display: inline-block;
      width: 2rem;
      height: 2rem;
      transform: rotate(45deg);

      &:before,
      &:after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        height: 50%;
        display: block;
        background-color: $gray-800;
        transform: translate(-50%, -50%);
      }

      &:before {
        width: 2px;
        height: 18px;
      }

      &:after {
        width: 18px;
        height: 2px;
      }
    }
  }
</style>
